import { Toast } from "@syncfusion/ej2-notifications";

export default {
  methods: {
    showToast(title, content, timeout) {
      if (timeout === undefined) timeout = 0;
      let toast = new Toast({
        title: title,
        content: content,
        showCloseButton: true,
        position: { X: "Right" },
        timeOut: timeout,
        cssClass: "custom-toast"
      });

      toast.appendTo("#notifyPopup");

      toast.show();
    }
  }
};
